import { useRecoilValue } from "recoil";
import { authState } from "src/store/auth";
import {
  atLeastOneBranchHasPermission,
  exactBranchHasPermission,
} from "src/utils";

export const useOneBranchHasPermission = () => {
  const { permissions } = useRecoilValue(authState);

  return (permissionKey: string) =>
    atLeastOneBranchHasPermission(permissions ?? [], permissionKey);
};

export const useExactBranchHasPermission = () => {
  const { permissions } = useRecoilValue(authState);

  return (permissionKey: string, branchId: number) =>
    exactBranchHasPermission(permissions ?? [], permissionKey, branchId);
};
